export const examples = {
  commandExampleCreateOrder: [
    {
      fieldName: 'Customer Name'
    },
    {
      fieldName: 'Product Name'
    },
    {
      fieldName: 'Delivery Time'
    },
    {
      fieldName: 'Delivery Address'
    },
    {
      fieldName: 'Quantity'
    },
    {
      fieldName: 'Comment'
    }
  ],
  commandExampleDeliverOrder: [
    {
      fieldName: 'Supplier'
    },
    {
      fieldName: 'Product Name'
    },
    {
      fieldName: 'Delivery Time'
    },
    {
      fieldName: 'Delivery Address'
    },
    {
      fieldName: 'Quantity'
    },
    {
      fieldName: 'Shipping Method'
    }
  ],
  readModelExampleOrder: [
    {
      fieldName: 'Customer'
    },
    {
      fieldName: 'Order'
    },
    {
      fieldName: 'Delivery Location'
    }
  ],
  readModelExampleCustomer: [
    {
      fieldName: 'Full Name'
    },
    {
      fieldName: 'Address'
    },
    {
      fieldName: 'Payment Method'
    }
  ],
  entityExampleCustomer: [
    {
      fieldName: 'Customer ID',
      tags: 'REQUIRED',
      exampleData: ['Example data', 'Example data', 'Example data'],
      primaryKey: true
    },
    {
      fieldName: 'Customer Name',
      tags: 'REQUIRED',
      exampleData: ['Example data', 'Example data', 'Example data']
    },
    {
      fieldName: 'Customer Address',
      tags: '',
      exampleData: ['Example data', 'Example data', 'Example data']
    },
    {
      fieldName: 'Phone Number',
      tags: '',
      exampleData: ['Example data', 'Example data', 'Example data']
    }
  ],
  entityExampleProduct: [
    {
      fieldName: 'Product ID',
      tags: 'REQUIRED',
      exampleData: ['Example data', 'Example data', 'Example data'],
      primaryKey: true
    },
    {
      fieldName: 'Product Name',
      tags: 'REQUIRED',
      exampleData: ['Example data', 'Example data', 'Example data']
    },
    {
      fieldName: 'Product Type',
      tags: 'REQUIRED',
      exampleData: ['Example data', 'Example data', 'Example data']
    },
    {
      fieldName: 'Stock Level',
      tags: '',
      exampleData: ['x', 'y', 'z']
    }
  ]
}
